import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown-filter"
// Usage: attach to the input element
//   data-dropdown-filter-list-value=".assigndropdown"
export default class extends Controller {
  static values = { list: String }

  connect() {
    this.element.addEventListener('input', this.filter.bind(this))
  }

  filter() {
    const value = this.element.value.toLowerCase()
    const items = document.querySelectorAll(`${this.listValue} a`)
    items.forEach(item => {
      const match = item.textContent.toLowerCase().includes(value)
      item.style.display = match ? '' : 'none'
    })
  }
}
